import { CiCdHeader } from "~/pages/cicd/utils/cicdTypes";

export const defaultTableHeaders: CiCdHeader[] = [
  { id: "RISK", label: "Risk", options: { align: "left" } },
  { id: "NAME", label: "Name", options: { align: "left" } },
  { id: "TYPE", label: "Type" },
  { id: "JOBID", label: "Job ID", options: { align: "left" } },
  { id: "AUTHOR", label: "Author", options: { align: "left" } },
];

export const jenkinsTableHeaders: CiCdHeader[] = [
  { id: "RISK", label: "Risk", options: { align: "left" } },
  { id: "NAME", label: "Name", options: { align: "left" } },
  { id: "TYPE", label: "Type" },
  { id: "JOBID", label: "Job ID", options: { align: "left" } },
];

export const k8sTableHeaders: CiCdHeader[] = [
  { id: "RISK", label: "Risk", options: { align: "left" } },
  { id: "NAME", label: "Namespace / Name", options: { align: "left" } },
  { id: "OPERATION", label: "Operation" },
  { id: "KIND", label: "Kind" },
  { id: "AUTHOR", label: "Author", options: { align: "left" } },
];

export const githubTableHeaders: CiCdHeader[] = [
  { id: "RISK", label: "Risk", options: { align: "left" } },
  { id: "NAME", label: "Name", options: { align: "left" } },
  { id: "TYPE", label: "Type" },
  { id: "RUN", label: "Run", options: { align: "left" } },
  { id: "AUTHOR", label: "Author", options: { align: "left" } },
];
